module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "copyright"
  }, [_vm._v("©"), _c('span', {
    attrs: {
      "id": "xmyear"
    }
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" XMission")]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-switch",
    attrs: {
      "id": "modeBox"
    }
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "modeSwitch"
    },
    on: {
      "click": _vm.darkmodeToggle
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "modeSwitch",
      "id": "modeSwitchLabel"
    }
  }, [_vm._v("Dark mode")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "footerLinks"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Services")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/utopia"
    }
  }, [_vm._v("UTOPIA Fiber")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cloud_hosting"
    }
  }, [_vm._v("Managed Hosting")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/web_hosting"
    }
  }, [_vm._v("Shared Hosting")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/colocation"
    }
  }, [_vm._v("Colocation")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/email_collaboration"
    }
  }, [_vm._v("Email")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/business_phone"
    }
  }, [_vm._v("Phone / VoIP")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Credentials")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/green/"
    }
  }, [_vm._v("100% Green Powered"), _c('br')]), _c('a', {
    attrs: {
      "href": "/soc2/"
    }
  }, [_vm._v("SOC 2")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/pci/"
    }
  }, [_vm._v("PCI DSS"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.bbb.org/utah/business-reviews/internet-services/xmission-in-salt-lake-city-ut-2001636"
    }
  }, [_vm._v("BBB Accredited")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/privacy-pledge/"
    }
  }, [_vm._v("Privacy Pledge")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/environment/"
    }
  }, [_vm._v("Energy Star Certified")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Social")]), _vm._v(" "), _c('i', {
    staticClass: "bi bi-bluesky"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bsky.app/profile/xmission.com"
    }
  }, [_vm._v("@xmission")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-bluesky"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bsky.app/profile/status.xmission.com"
    }
  }, [_vm._v("@xmissionstatus")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-facebook"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/pages/XMission/6155383019"
    }
  }, [_vm._v("facebook")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-instagram"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/xmission/"
    }
  }, [_vm._v("instagram")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-linkedin"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/33375?trk=NUS_CMPY_TWIT"
    }
  }, [_vm._v("linkedin")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-star-fill"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/reviews"
    }
  }, [_vm._v("Review us")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd5a009","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot.vue
// module id = 1307
// module chunks = 16